@if (store.asArray(); as roles) {
  <div class="grid">
    <div class="col-7">
      @if (roles.length > 0) {
        <p-table
          #roleTable
          [globalFilterFields]="['name']"
          [loading]="loading"
          [value]="roles">
          <ng-template pTemplate="caption">
            <app-table-list-caption
              [searchWord]="searchWord"
              (clearTable)="clear(roleTable)"
              (search)="
                roleTable.filterGlobal($event, 'contains')
              "></app-table-list-caption>
          </ng-template>
          <ng-template pTemplate="header">
            <tr>
              <th>Rolle</th>
              <th>Nutzer:innen</th>
              <th>Aktionen</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-role>
            <tr>
              <td>
                <div class="flex flex-column gap-2">
                  {{ role.name }}
                  <div class="flex flex-wrap gap-2">
                    @for (accessKey of accessList; track $index) {
                      @if (role.accessList[accessKey.key]) {
                        <p-chip
                          [label]="accessKey.name"
                          styleClass="p-chip-xs text-xs" />
                      }
                    }
                  </div>
                </div>
              </td>
              <td>
                <p-tag
                  [severity]="
                    getRoleUsers(role._id).length > 0 ? undefined : 'secondary'
                  ">
                  <span
                    class="flex gap-2 align-items-center"
                    [pTooltip]="getRoleUserTooltip(role._id)"
                    tooltipPosition="top">
                    <i class="fas fa-users mr-1"></i>
                    {{ getRoleUsers(role._id).length }}
                  </span>
                </p-tag>
              </td>
              <td>
                <app-table-list-actions
                  [item]="role"
                  (confirm)="confirm($event, role, role.name)">
                </app-table-list-actions>
              </td>
            </tr>
          </ng-template>
        </p-table>
      } @else {
        <app-alert
          styleClass="m-0 p-3 pt-1"
          header="Keine Einträge gefunden"
          [canToggle]="false">
          Legen Sie
          <a [routerLink]="[{ outlets: { bearbeiten: 'neu' } }]">Rollen</a> an,
          um Nutzer:innen verschiedene Aufgaben zuzuweisen.
        </app-alert>
      }
    </div>
    <div class="col-5">
      <app-header
        text="Vorlagen"
        sub="Übertragen Sie gängige Rollen mit einem Klick in Ihr System."
        icon="fas fa-clipboard-user"
        styleClass="mt-1 mb-4"></app-header>

      @for (template of roleTemplates; track $index) {
        <div
          class="p-card mb-3 p-3 flex flex-column gap-3 cursor-pointer hover:bg-primary-100"
          pTooltip="Zum hinzufügen klicken"
          [ngClass]="{
            'text-color-secondary pointer-events-none surface-ground':
              !availableTemplateKeys.includes(template.key || ''),
          }"
          (click)="addRole(template)">
          <app-header
            [icon]="template['icon'] || 'fas fa-user-tag'"
            [text]="template.name"
            styleClass="m-0 text-lg"
            [sub]="template['sub']"></app-header>

          @if (availableTemplateKeys.includes(template.key || '')) {
            <div class="flex flex-wrap gap-2">
              @for (accessKey of accessList; track $index) {
                @if (template.accessList[accessKey.key]) {
                  <p-chip
                    [label]="accessKey.name"
                    styleClass="p-chip-xs text-xs" />
                }
              }
            </div>
          } @else {
            <div
              class="text-color-secondary font-italic flex gap-2 align-items-baseline text-xs">
              <i class="fas fa-check-circle"></i> Eine Rolle mit den Rechten
              dieses Templates ist bereits vorhanden.
            </div>
          }
        </div>
      }
    </div>
  </div>
}

<p-sidebar
  (onHide)="onOverlayClose()"
  position="right"
  [modal]="false"
  [styleClass]="'w-5'"
  [visible]="editFormOverlay">
  <ng-template pTemplate="header">
    <app-header
      [icon]="editFormOverlayIcon"
      [text]="editFormOverlayHeader"></app-header
  ></ng-template>

  <ng-container *ngIf="editFormOverlay">
    <router-outlet name="bearbeiten"></router-outlet>
  </ng-container>
</p-sidebar>
<app-mask [visible]="editFormOverlay" (click)="onOverlayClose()"></app-mask>
